import { render, staticRenderFns } from "./ShowcaseSlider.vue?vue&type=template&id=518d945c&scoped=true"
import script from "./ShowcaseSlider.vue?vue&type=script&lang=js"
export * from "./ShowcaseSlider.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseSlider.vue?vue&type=style&index=0&id=518d945c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d945c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VImg,VTooltip})
